(function ($) {

  let updateProgressbar = function (ele, nextSlide) {
    let index = parseInt(nextSlide) + 1;
    let totalSlide = ele.find('.slide-title').length;
    let progress = (index / totalSlide) * 100;
    ele.find('.slider-progress').width(progress + '%');
    ele.find('.slider-current-index').html(index < 10 ? '0' + index : index);
    ele.find('.slide-title').removeClass('active');
    ele.find('.slide-title').eq(parseInt(nextSlide)).addClass('active');
  };

  if ($('.section--slider-3__wrapper').length) {

    let _viewWidth = window.innerWidth;

    $(window).resize(function () {
      _viewWidth = window.innerWidth;
    });

    $('.section--slider-3__wrapper').each(function () {

      let _this = $(this);
      let _slickOptions = {
        arrows: false,
        dots: false,
        slide: '.slide-wrapper',
      };
      let _mainSlide = _this.find('.slides-image-wrapper').slick(_slickOptions);
      let _sideTitle = _this.find('.slide-title-wrapper');

      _mainSlide.on('afterChange', function (event, slick, nextSlide) {
        updateProgressbar(_this, nextSlide);
        if (_viewWidth < 992) {
          let _SL = 0;
          for (let i = 0; i < nextSlide; i++) {
            _SL += _this.find('.slide-title').eq(i).outerWidth();
          }
          _this.find('.slides-title-list').scrollLeft(_SL);
        }
      });

      _sideTitle.find('.slide-title').click(function (e) {
        e.preventDefault();
        _mainSlide.slick('slickGoTo', $(this).attr('data-id'));
      });

      _this.find('.slider-next').click(function (e) {
        e.preventDefault();
        _mainSlide.slick('slickNext');
      });

      _this.find('.slider-prev').click(function (e) {
        e.preventDefault();
        _mainSlide.slick('slickPrev');
      });

    });
  }

})(jQuery);
